import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 全部游戏
interface MyGamesJson {
    token: string,
}
export const myGames = (json: MyGamesJson): any => http.httpPost({
    url: httpApi.game.myGames,
    json,
})

// 删除游戏
interface DelLatelyGameJson {
    token: string,
    box_game_id: object,
}
export const delLatelyGame = (json: DelLatelyGameJson): any => http.httpPost({
    url: httpApi.game.delLatelyGame,
    json,
})

// 游戏详情
interface GameInfoJson {
    token: string,
    box_game_id: string,
}
export const gameInfo = (json: GameInfoJson): any => http.httpPost({
    url: httpApi.game.gameInfo,
    json,
})

// 游戏礼包码
interface GetGameGiftCodeJson {
    token: string,
    box_game_id: any,
}
export const getGameGiftCode = (json: GetGameGiftCodeJson): any => http.httpPost({
    url: httpApi.game.getGameGiftCode,
    json,
})

// 同厂推荐
interface FirmRecommendJson {
    token: string,
    box_game_id: string,
    factory_id: string
}
export const firmRecommend = (json: FirmRecommendJson): any => http.httpPost({
    url: httpApi.game.firmRecommend,
    json,
})

// 直接启动游戏
interface EnterGameJson {
    token: string,
    box_game_id: string,
    serverid: string
}
export const EnterGame = (json: EnterGameJson): any => http.httpPost({
    url: httpApi.game.EnterGame,
    json,
})

// 启动游戏登录器
interface EnterGameClientJson {
    box_game_id: string,
    token: string,
}
export const EnterGameClient = (json: EnterGameClientJson): any => http.httpPost({
    url: httpApi.game.EnterGameClient,
    json,
})

export const getServerList = (urls: string) => http.httpGet({
    url: urls,
})

export const getGameLink = () => http.httpGet({
    url: httpApi.game.getGameLink,
})
